
























import { Component, Vue, Prop } from "vue-property-decorator"
import { CatalogItem } from '../services/ContentService'
import ImageSlider from './ImageSlider.vue'

@Component({
  components: {
    ImageSlider,
  }
})
export default class CatalogView extends Vue {
  @Prop(Object) item!: CatalogItem
  @Prop(Number) index!: number

  get classes () {
    return {
      'is-reverse': this.index % 2
    }
  }

}
